import React, { useState, useEffect, useCallback } from 'react';
import { Card, CardBody, Button, Table } from 'reactstrap';
import api from '../../services/api';
import NewLeagueAdminModal from './NewLeagueAdminModal';

const LeagueAdmins = ({ league }) => {
    const [admins, setAdmins] = useState([]);
    const [newAdminModal, setNewAdminModal] = useState(false);

    const toggleNewModal = () => setNewAdminModal(!newAdminModal);

    const fetchAdmins = useCallback(async () => {
        try {
            const response = await api.get(`/league-admins/?league=${league.id}`);
            setAdmins(response.data);
        } catch (error) {
            console.error('Error fetching league admins:', error);
        }
    }, [league.id]);

    useEffect(() => {
        if (league?.id) {
            fetchAdmins();
        }
    }, [league?.id, fetchAdmins]);

    const handleAddAdmin = async (adminData) => {
        try {
            await api.post('/league-admins/', adminData);
            fetchAdmins();
            toggleNewModal();
        } catch (error) {
            console.error('Error adding admin:', error);
            alert('Error adding admin: ' + (error.response?.data?.detail || error.message));
        }
    };

    const handleDeleteAdmin = async (adminId) => {
        if (!window.confirm('Are you sure you want to remove this admin from the league?')) {
            return;
        }
        try {
            await api.delete(`/league-admins/${adminId}/`);
            fetchAdmins();
        } catch (error) {
            console.error('Error deleting admin:', error);
            alert('Error deleting admin: ' + (error.response?.data?.detail || error.message));
        }
    };

    if (!league?.id) {
        return <p className="text-muted small">Select a league to manage its admins.</p>;
    }

    return (
        <>
            <Card className="mt-3">
                <CardBody className="pt-3">
                    {admins.length === 0 ? (
                        <p className="text-muted small">No admins assigned to this league.</p>
                    ) : (
                        <Table bordered hover size="sm" responsive>
                            <thead className="table-light">
                                <tr>
                                    <th>Email</th>
                                    <th style={{ width: '100px' }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {admins.map((admin) => (
                                    <tr key={admin.id}>
                                        <td>{admin.email}</td>
                                        <td>
                                            <Button color="danger" size="sm" onClick={() => handleDeleteAdmin(admin.id)}>
                                                Remove
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    )}
                    <div className="mt-3">
                        <Button color="success" size="sm" onClick={toggleNewModal}>
                            + Add Admin
                        </Button>
                    </div>
                </CardBody>
            </Card>

            <NewLeagueAdminModal
                isOpen={newAdminModal}
                toggle={toggleNewModal}
                onSave={handleAddAdmin}
                leagueId={league?.id}
            />
        </>
    );
};

export default LeagueAdmins;
